module.exports = __webpack_public_path__ + "img/user_male.6db37c19.svg";